/* RAD LVNG — add-to-cart button feedback (DRAFT). v29.
   Covers the compact cross-sell cards (.xcell__cta button[name=add]), the main PDP add-to-cart
   button (.product-form__submit), AND the grid/home card direct-add button
   (button.quick-add__submit[name=add] — single-variant cards). The theme's product-form.js does
   the real add + opens the cart drawer; we OWN the button feedback: instant spinner ring on click
   (held a min time so a fast add is still SEEN), then flip green + 'added ✓' once the add settles. */
(function () {
  if (window.__radXsellInit) return; window.__radXsellInit = true;

  function feedback(btn, busyClass, addedClass, textSel, addedText) {
    if (btn.__radBusy) return; btn.__radBusy = true;
    var textEl = textSel ? btn.querySelector(textSel) : null;
    var orig = textEl ? textEl.textContent : '';
    btn.classList.add(busyClass);                       /* instant: ring shows, text hides */
    var start = Date.now(), MIN = 550, MAX = 8000;
    var iv = setInterval(function () {
      var elapsed = Date.now() - start;
      var settled = !btn.classList.contains('loading') && btn.getAttribute('aria-disabled') !== 'true';
      if (settled && elapsed >= MIN) {
        clearInterval(iv);
        btn.classList.remove(busyClass);
        btn.classList.add(addedClass);
        if (textEl) textEl.textContent = addedText;
        setTimeout(function () { btn.classList.remove(addedClass); if (textEl) textEl.textContent = orig; btn.__radBusy = false; }, 1900);
      } else if (elapsed > MAX) {
        clearInterval(iv); btn.classList.remove(busyClass); if (textEl) textEl.textContent = orig; btn.__radBusy = false;
      }
    }, 90);
  }

  document.addEventListener('click', function (e) {
    var x = e.target.closest('.xcell__cta button[name="add"]');
    if (x && !x.hasAttribute('disabled') && !x.classList.contains('xcell__btn--added')) {
      feedback(x, 'xcell__btn--busy', 'xcell__btn--added', '.xcell__btn-text', 'added ✓'); return;
    }
    var m = e.target.closest('.product-form__submit');
    if (m && !m.hasAttribute('disabled') && m.getAttribute('aria-disabled') !== 'true' && !m.classList.contains('rad-added')) {
      feedback(m, 'rad-busy', 'rad-added', 'span', 'added ✓'); return;
    }
    /* grid/home card direct-add (single-variant). Bare-text button → no text node to swap, so the
       'added ✓' label is painted by CSS via .quick-add__submit.rad-added::after (textSel=null). */
    var q = e.target.closest('button.quick-add__submit[name="add"]');
    if (q && !q.hasAttribute('disabled') && q.getAttribute('aria-disabled') !== 'true' && !q.classList.contains('rad-added')) {
      feedback(q, 'rad-busy', 'rad-added', null, 'added ✓'); return;
    }
  }, false);
})();
